const Layout = r => require(['@/pages/PageLayout'], r);

// 消息
const newHomeMessage = r => require(["@/pages/new-home-message/index"], r);
// 消息详情
const newHomeMessageDetail = r =>
  require(["@/pages/new-home-message/components/message-detail"], r);

export default {
  path: "/new-home-message",
  component: Layout,
  redirect: "/new-home-message/index",
  children: [
    {
      path: "/new-home-message/index",
      component: newHomeMessage
    },
    {
      path: "/new-home-message/detail",
      component: newHomeMessageDetail
    }
  ]
};
